import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Subject, takeUntil } from 'rxjs';
import { ApplicationType } from 'src/app/core/constants/dropdown-contants';
import { ApplicationStatusService } from 'src/app/core/services/application-status/application-status.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { ToasterService } from 'src/app/core/services/toaster/toaster.service';
import { UniversityCommunicationService } from 'src/app/core/services/university-communication/university-communication.service';
import { CamsIdSearchComponent } from '../cams-id-search/cams-id-search.component';
import { ApplicationMasterService } from 'src/app/core/services/applicationMaster/application-master.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { PaginationType } from 'src/app/core/interfaces/pagination/pagination-type';
import { PageEvent } from '@angular/material/paginator';
import { PaginationConfigService } from 'src/app/core/services/paginationconfig.service';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { PopUpService } from 'src/app/core/services/pop-up/pop-up.service';

@Component({
    selector: 'app-assign-mail',
    templateUrl: './assign-mail.component.html',
    styleUrls: ['./assign-mail.component.scss'],
})
export class AssignMailComponent implements OnInit, OnDestroy {
    assign_mail_form: FormGroup;
    primary_status_list: any;
    secondary_status_list: any;
    application_type = ApplicationType;
    private _unsubscribeAll: Subject<any> = new Subject();
    dataSource = new MatTableDataSource<any>();
    show_app_table: boolean = false;
    urlRoutes = urlRoutes
    displayedColumns: string[] = [
        'camsID',
        'store',
        'studentName',
        'courseName',
        'universityName',
        'primaryStatus',
        'secondaryStatus',
    ];
    public select_all: boolean = false;
    selected_cams: any;

    pagination_config: PaginationType = {
        size: 10,
        total: 0,
        skip: 0,
        limit: 10
    };
    pagination_secondary_config: PaginationType = {
        size: 10,
        total: 0,
        skip: 0,
        limit: 100
    };

    filterData: any

    constructor(
        public dialogRef: MatDialogRef<AssignMailComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _loaderService: LoaderService,
        private _fb: FormBuilder,
        private _applicationStatusService: ApplicationStatusService,
        private _universitycommunicationService: UniversityCommunicationService,
        private _toasterService: ToasterService,
        public dialog: MatDialog,
        private _appMasterService: ApplicationMasterService,
        private paginationConfigService: PaginationConfigService,
        private _lc: LocalStorageService,
        private _popUpService: PopUpService
    ) { }

    ngOnInit(): void {
        this.paginationConfigService.pageSize$.subscribe((newSize: number) => {
            this.pagination_config.size = newSize;
            this.pagination_config.limit = newSize;
        });
        this.initiateForm();
        this.getPrimarySTatus();
        if (this.data?.filter) {
            this.filterData = this.data?.filter
            this.getApplications(this.filterData);
        }
    }

    initiateForm() {
        this.assign_mail_form = this._fb.group({
            applicationId: ['', Validators.required],
            primaryStatus: [''],
            primaryStatusId: [''],
            secondaryStatus: [''],
            secondaryStatusId: [''],
            showAgent: [false],
        });
    }

    close(value?: any) {
        this.dialogRef.close(value);
    }

    private getPrimarySTatus(): void {
        this._loaderService.showLoader();
        this._applicationStatusService
            .getPrimaryStatusesList()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this.primary_status_list = res?.data?.data;
                    this._loaderService.hideLoader();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    primaryStatusChange(event: MatSelectChange) {
        let find_primary = this.primary_status_list.find(
            (element) => element.id === event.value
        );
        if (find_primary) {
            this.assign_mail_form
                .get('primaryStatus')
                .setValue(find_primary.primaryStatus);
        }
        this.getSecondaryStatus(event.value);
    }

    getSecondaryStatus(id: any) {
        this._loaderService.showLoader();
        this._applicationStatusService
            .getSecondaryStatusesbyId(id, this.pagination_secondary_config)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (res) => {
                    this.secondary_status_list = res?.data?.data;
                    this._loaderService.hideLoader();
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    secondaryStatusChange(event: MatSelectChange) {
        let find_secondary = this.secondary_status_list.find(
            (element) => element.id === event.value
        );
        if (find_secondary) {
            this.assign_mail_form
                .get('secondaryStatus')
                .setValue(find_secondary.secondaryStatus);
        }
    }

    assignAndDone(isDone) {
        let form_values = this.assign_mail_form.value;
        if (!form_values.applicationId) {
            this._universitycommunicationService.openWarningPopup('cams');
            return;
        }
        if (!this.data.selected_mails?.length) {
            this._universitycommunicationService.openWarningPopup('');
            return;
        }
        this.assign(isDone)
        return;
        this._popUpService.showConfirmationPopup(
            'Are you sure?',
            `You want to confrim this action?`,
            'Yes',
            (isConfirmed: boolean) => {
                if (isConfirmed) {
                    setTimeout(() => {
                        this.assign(isDone);
                    }, 200)
                }
            },
            false,
            'No'
        );
    }

    assign(isDone: boolean = false) {
        let form_values = this.assign_mail_form.value;
        if (!form_values.applicationId) {
            this._universitycommunicationService.openWarningPopup('cams');
            return;
        }
        if (!this.data.selected_mails?.length) {
            this._universitycommunicationService.openWarningPopup('');
            return;
        }
        if (this.data?.isReassign) {
            const userDetails = this._lc.getUser();
            let payload = `Id=${this.data.selected_mails}&type=0&userId=${userDetails?.id}&userName=${userDetails?.name}&applicationId=${form_values.applicationId}&showAgent=${form_values.showAgent}`;
            this._loaderService.showLoader();
            this._universitycommunicationService
                .reAssignMail(payload)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (res: any) => {
                        if (res?.statusCode === 200 && res?.success) {
                            this.close({
                                isDone,
                                close: true
                            });
                            this._toasterService.showSuccess(
                                'SUCCESS',
                                'Re assigned successfully'
                            );
                            if (!isDone) {
                                this._loaderService.hideLoader();
                            }
                        }
                        else {
                            this._loaderService.hideLoader();
                            this._toasterService.showError(
                                'ERROR!',
                                res?.message
                            );
                        }
                    },
                    (err) => {
                        this._loaderService.hideLoader();
                    }
                );

        } else {
            this._loaderService.showLoader();

            let payload = `messageId=${this.data.selected_mails}&applicationId=${form_values.applicationId}&primaryStatus=${form_values.primaryStatus}&primaryStatusId=${form_values.primaryStatusId}&secondaryStatus=${form_values.secondaryStatus}&secondaryStatusId=${form_values.secondaryStatusId}&showAgent=${form_values.showAgent}`;

            this._universitycommunicationService
                .assignMail(payload)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(
                    (res: any) => {
                        if (res?.statusCode === 200 && res?.success) {
                            //this.close(true);
                            this.close({
                                isDone,
                                close: true
                            });
                            this._toasterService.showSuccess(
                                'SUCCESS',
                                res?.data
                            );
                            if (!isDone) {
                                this._loaderService.hideLoader();
                            } else {
                                this._loaderService.showLoader();
                            }
                        } else {
                            this._loaderService.hideLoader();
                            this._toasterService.showError(
                                'ERROR!',
                                res?.message
                            );
                        }
                    },
                    (err) => {
                        this._loaderService.hideLoader();
                    }
                );
        }
    }

    openCAMSSearchPopup() {
        const dialogRef = this.dialog.open(CamsIdSearchComponent, {
            width: '40%',
            enterAnimationDuration: '300ms',
            exitAnimationDuration: '100ms',
            data: {},
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.filterData = result;
                this.getApplications(this.filterData);
            }
        });
    }

    getApplications(filter: any) {
        this._loaderService.showLoader();
        this._appMasterService
            .getApplication(this.pagination_config, filter)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                (result) => {
                    if (result) {
                        const data = this.getCovertedArray(
                            result?.data?.data || []
                        );
                        this.dataSource = new MatTableDataSource(data);
                        this.pagination_config.total = result?.data?.total;
                        this.show_app_table = true;
                        this._loaderService.hideLoader();
                    }
                },
                (err) => {
                    this._loaderService.hideLoader();
                }
            );
    }

    private getCovertedArray(data: any): any[] {
        const converted = data.map((item: any) => {
            return {
                id: item?.id,
                store: item?.tenantName,
                name: `${item?.studentPersonalDetailsRef?.firstName} ${item?.studentPersonalDetailsRef?.lastName}`,
                student: item?.studentPersonalDetailsRef,
                coursesDetails: item?.coursesDetails,
                coursesEnrolement: item?.coursesEnrolementRef,
                universityDetails: item?.universityDetails,
                primaryStatus: item?.currentStatus?.primaryStatus,
                secondaryStatus: item?.currentStatus?.secondaryStatus,
                masterId: item?.masterId,
                dynamicUrl: this.buildDynamicUrl(item)
            };
        });
        return converted;
    }

    private buildDynamicUrl(element: any): string {
        return `${this.urlRoutes.mainLayout}/${this.urlRoutes.application_master}/${this.urlRoutes.app_master_info}/${element.id}/${element.masterId}/${element?.coursesEnrolement?.universityId}`;
    }

    public SelectAllTenant(event: MatCheckboxChange): void {
        this.dataSource.filteredData.forEach((item: any) => {
            item.isSelected = event.checked;
        });
        this.getSelectedCAMS();
    }

    public selectIndividual(event: MatCheckboxChange, index: number): void {
        // const selected_cams = this.dataSource.filteredData.filter((item: any) => item.isSelected);
        // const total_cams = this.dataSource.filteredData.length;
        // this.dataSource.filteredData[index]['isSelected'] = event.checked;
        // if (selected_cams.length === total_cams) {
        //   this.select_all = true;
        // } else {
        //   this.select_all = false;
        // }
        this.dataSource.filteredData.forEach(
            (element: any, item_ind: number) => {
                if (index === item_ind) {
                    element['isSelected'] = event.checked;
                } else {
                    element['isSelected'] = false;
                }
            }
        );
        this.getSelectedCAMS();
    }

    getSelectedCAMS() {
        this.selected_cams = this.dataSource.filteredData;
        this.selected_cams = this.selected_cams
            .filter((element) => element.id && element.isSelected)
            .map((element) => {
                return element.id;
            });

        this.assign_mail_form
            .get('applicationId')
            .setValue(this.selected_cams?.toString());
    }

    public pagination(event: PageEvent) {
        this.pagination_config = {
            ...this.pagination_config,
            skip: event.pageIndex * event.pageSize,
            limit: event.pageSize
        }
        this.getApplications(this.filterData);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
